import script from "./documents.vue?vue&type=script&setup=true&lang=js"
export * from "./documents.vue?vue&type=script&setup=true&lang=js"

import "./documents.vue?vue&type=style&index=0&id=704e4711&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-704e4711"]])

export default __exports__